export const legends = [
  {
    number: 'LD100',
    hasModel: false
  },
  {
    number: 'LD101',
    hasModel: false
  },
  {
    number: 'LD102',
    hasModel: false
  },
  {
    number: 'LD103',
    hasModel: false
  },
  {
    number: 'LD104',
    hasModel: false
  },
  {
    number: 'LD105',
    hasModel: false
  },
  {
    number: 'LD106',
    hasModel: false
  },
  {
    number: 'LD107',
    hasModel: false
  },
  {
    number: 'LD108',
    hasModel: false
  },
  {
    number: 'LD109',
    hasModel: false
  },
  {
    number: 'LD110',
    hasModel: false
  },

]